"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VSpinner = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("@blueprintjs/core");
var style_1 = require("./style");
var VSpinner = function (props) {
    return (react_1.default.createElement(style_1.SpinnerContainer, { hasBackdrop: props.hasBackdrop, color: props.color },
        react_1.default.createElement(core_1.Spinner, { intent: props.intent || core_1.Intent.PRIMARY, size: props.size || 50 })));
};
exports.VSpinner = VSpinner;
